import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAuthServiceConfig, getAuthUser, setAuthServiceAccessExpiry } from "../services/salescodeAuthService";
import { setAuthContext } from "../services/authenticationService";
import { openPopup } from "../stateManagement/actions/popupActions";
import { EnvironmentRegistry } from "../services/registry/environmentRegistry";

export function AutoLoginHandler({ onDone }: { onDone: () => void }) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        let accessToken = null;
        let accessTokenExpiresIn = null;
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        const accessTokenCookie = cookies.find(cookie => cookie.startsWith('accessToken='));
        if (accessTokenCookie) {
            accessToken = accessTokenCookie.split('=').slice(1).join('=');
        }
        const accessTokenExpiresInCookie = cookies.find(cookie => cookie.startsWith('accessTokenExpiresIn='));
        if (accessTokenExpiresInCookie) {
            accessTokenExpiresIn = accessTokenExpiresInCookie.split('=')[1];
            setAuthServiceAccessExpiry(Number(accessTokenExpiresIn));
        }
        if (accessToken != null) {
            sessionStorage.setItem("access_token", accessToken);
        }
        const environment = EnvironmentRegistry.getEnvironment()?.toString() || "";
        localStorage.setItem("env", environment);
        getAuthServiceConfig(environment);
        if (accessToken && !localStorage.getItem("authContext")) {
            (async () => {
                try {
                    const response = await getAuthUser(accessToken);
                    if (response && response.status === 200 && response.data?.user) {
                        setAuthContext(response.data.user, accessToken);
                        if (response.data.user.lob) {
                            localStorage.setItem("lob", response.data.user.lob);
                        }
                        navigate("/dashboard");
                    } else {
                        openPopup("Error", "Invalid or expired access token.");
                    }
                } catch (err) {
                    openPopup("Error", "Auto-login failed. Please login manually.");
                }
            })();
        }
        onDone();
    }, []);

    return null;
}
